/**
 * Situação dos lançamentos num relatório (ADR 0063).
 *
 * - `all` (padrão): concluídas + pendentes + Ocorrência projetada de recorrência. Responde
 *   "como o período fecha se tudo se efetivar" — a leitura que faltava quando o seletor de
 *   período ia até dezembro e a query só via o passado.
 * - `settled`: só `isConfirmed = 1`. É o comportamento histórico do relatório.
 * - `pending`: só o que ainda NÃO se efetivou. Responde "o que falta acontecer".
 *
 * `settled` NÃO é a preferência "Apenas efetivadas" do extrato (`settledOnly`), que é mais
 * estrita: lá a compra no cartão só conta se a fatura foi totalmente paga. Aqui é só o
 * `isConfirmed` — por isso o rótulo é **Concluídas**, o mesmo que o extrato usa no divisor.
 */
export type ReportStatusFilter = 'all' | 'settled' | 'pending';

export const DEFAULT_REPORT_STATUS: ReportStatusFilter = 'all';

/** O que passar em `isConfirmed`: `undefined` = sem corte (as duas pontas). */
export function confirmedFilterFor(status: ReportStatusFilter): boolean | undefined {
    if (status === 'settled') return true;
    if (status === 'pending') return false;
    return undefined;
}

/**
 * Ocorrência projetada entra? Em `settled` nunca — uma projeção não está confirmada por
 * definição, e `getTransactions` já ignora a projeção quando `isConfirmed === true`.
 */
export function includesProjected(status: ReportStatusFilter): boolean {
    return status !== 'settled';
}

/** O realizado entra no total? Em `pending` a leitura é só do que falta. */
export function includesSettled(status: ReportStatusFilter): boolean {
    return status !== 'pending';
}
